// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_oq-0";
export var discountCodeInput = "_oq-1";